import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { IMAGE_URL } from "network";
import { useEffect, useState } from "react";
import { uploadImage } from "services/imageUpload";

function AddForm({ open, onClose, initialData, onSubmit }) {
  const [previewUrl2, setPreviewUrl2] = useState("");

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: initialData
      ? {
          _id: initialData._id,
          name: initialData.name || "",
          thumbnail: initialData.thumbnail || "",
          url: initialData.url || "",
          decription: initialData.decription || "",
        }
      : {
          name: "",
          thumbnail: "",
          url: "",
          decription: "",
        },

    validationSchema: Yup.object({
      name: Yup.string().required("Category name is required"),
      thumbnail: Yup.string().required("Thumbnail is required"),
      decription: Yup.string().required("decription is required"),
      url: Yup.string()
        .matches(
          /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.?be)\/.+$/,
          "Enter a valid YouTube link"
        )
        .required("YouTube link is required"),
    }),

    onSubmit: async (values) => {
      const payload = { ...values };
      if (!values._id) delete payload._id; // 🚀 remove empty _id
      await onSubmit(payload);
    },
  });

  useEffect(() => {
    if (initialData?.thumbnail) {
      setPreviewUrl2(IMAGE_URL + initialData.thumbnail);
    }
  }, [initialData]);

  const handleFileChange = async (field, file) => {
    formik.setFieldValue(field, file);
    if (file) {
      const imageName = await uploadImage(file);
      setPreviewUrl2(IMAGE_URL + imageName);
      formik.setFieldValue("thumbnail", imageName);
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{initialData ? "Edit" : "Add"}</DialogTitle>
      <form onSubmit={formik.handleSubmit}>
        <DialogContent dividers>
          <TextField
            name="name"
            label="Name"
            value={formik.values.name}
            onChange={formik.handleChange}
            error={formik.touched.name && Boolean(formik.errors.name)}
            helperText={formik.touched.name && formik.errors.name}
            fullWidth
            margin="normal"
          />

          <TextField
            name="decription"
            label="Description"
            value={formik.values.decription}
            onChange={formik.handleChange}
            error={
              formik.touched.decription && Boolean(formik.errors.decription)
            }
            helperText={formik.touched.decription && formik.errors.decription}
            fullWidth
            margin="normal"
          />

          <TextField
            name="url"
            label="YouTube Link"
            value={formik.values.url}
            onChange={formik.handleChange}
            error={formik.touched.url && Boolean(formik.errors.url)}
            helperText={formik.touched.url && formik.errors.url}
            fullWidth
            margin="normal"
          />

          <Typography variant="h6">Thumbnail Image (250*380)</Typography>
          <input
            type="file"
            accept="image/*"
            onChange={(e) => handleFileChange("thumbnail", e.target.files[0])}
            style={{ marginTop: 16 }}
          />
          {formik.touched.thumbnail && formik.errors.thumbnail && (
            <Typography color="error" variant="caption">
              {formik.errors.thumbnail}
            </Typography>
          )}
          {previewUrl2 && (
            <img
              crossOrigin="anonymous"
              src={previewUrl2}
              alt="Preview"
              style={{
                marginTop: 16,
                width: "100px",
                maxHeight: 200,
                objectFit: "cover",
                borderRadius: 8,
              }}
            />
          )}
        </DialogContent>

        <DialogActions>
          <Button onClick={onClose} color="secondary">
            Cancel
          </Button>
          <Button type="submit" color="primary" variant="contained">
            {initialData ? "Update" : "Add"}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}

export default AddForm;
